/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
import { InputAdornment, TextField, styled } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { forwardRef } from 'react';

const StyledSearch = styled(TextField)(({ theme: { palette } }) => ({
  padding: "0rem 0.75rem 0.5rem 0.75rem",
  borderBottom: `1px solid ${palette.theme?.secondary[200]}`,
  input: {
    padding: "0.5rem 0rem",
  },
  ".MuiOutlinedInput-notchedOutline": {
    border: 0,
  },
  "& .MuiOutlinedInput-root": {
    fontSize: "0.8125rem",
    paddingLeft: "0.5rem",
    color: palette.theme?.secondary[800],
    // backgroundColor: palette.theme?.secondary[200],
    border: "1px solid #F5F6F5",
    borderRadius: "0.5rem",
    ":hover .MuiOutlinedInput-notchedOutline": {
      border: 1,
    },
    "&.Mui-focused fieldset": {
      border: 0,
    },
  },
}));

const SelectSearch = forwardRef<HTMLInputElement, any>(
  ({ searchPlaceholder, handleSearch, value, ...rest }, ref) => (
    <StyledSearch
      inputRef={ref} // Attach the ref here for focusing
      placeholder={searchPlaceholder}
      onChange={handleSearch}
      value={value}
      fullWidth
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  )
);

export { SelectSearch };
export default SelectSearch;
